import React from 'react';
import { fmtDate, WEEKDAY_SHORT } from './AttendancePage';

const CELL_COLORS = {
  present: 'bg-green-500 text-white',
  absent:  'bg-red-400 text-white',
  null:    'bg-gray-200 text-gray-500',
};
const CELL_LABELS = { present: 'N', absent: 'F', null: '–' };

const AttendanceWeekView = ({
  participants,
  weekDates,
  getEffectiveStatus,
  mode,
  selected,
  onToggleSelect,
  onCellClick,
}) => (
  <div data-testid="week-view" className="overflow-x-auto">
    <table className="text-xs min-w-full border-collapse">
      <thead>
        <tr className="border-b">
          {mode === 'register' && <th className="w-8" />}
          <th className="sticky left-0 bg-white z-10 text-left py-2 px-3 font-bold min-w-[140px]">Namn</th>
          {weekDates.map((d, i) => (
            <th key={i} className="py-2 px-2 font-bold text-center min-w-[60px]">
              <div>{WEEKDAY_SHORT[i]}</div>
              <div className="text-muted-foreground font-normal">{d.getDate()}/{d.getMonth() + 1}</div>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {participants.map(p => (
          <tr
            key={p.id}
            data-testid={`week-row-${p.id}`}
            className={`border-b ${selected.has(p.id) ? 'bg-yellow-50' : 'hover:bg-muted/20'}`}
          >
            {mode === 'register' && (
              <td className="py-2 px-2 text-center">
                <input
                  type="checkbox"
                  data-testid={`week-select-${p.id}`}
                  checked={selected.has(p.id)}
                  onChange={() => onToggleSelect(p.id)}
                  className="rounded"
                  aria-label={`Välj ${p.name}`}
                />
              </td>
            )}
            <td className="sticky left-0 bg-white z-10 py-2 px-3 font-medium">{p.name}</td>
            {weekDates.map((d, i) => {
              const dateStr = fmtDate(d);
              const status  = getEffectiveStatus(p.id, dateStr);
              return (
                <td key={i} className="py-2 px-2 text-center">
                  <button
                    type="button"
                    data-testid={`week-cell-${p.id}-${dateStr}`}
                    onClick={() => mode === 'register' && onCellClick(p.id, dateStr)}
                    className={`w-8 h-8 rounded-full text-xs font-bold transition-colors ${CELL_COLORS[status ?? 'null']} ${mode === 'register' ? 'cursor-pointer hover:opacity-80' : 'cursor-default'}`}
                    disabled={mode === 'overview'}
                    aria-label={`${p.name} ${dateStr}: ${status ?? 'Ej registrerad'}`}
                  >
                    {CELL_LABELS[status ?? 'null']}
                  </button>
                </td>
              );
            })}
          </tr>
        ))}
        {participants.length === 0 && (
          <tr>
            <td colSpan={weekDates.length + (mode === 'register' ? 2 : 1)} className="py-8 text-center text-muted-foreground">
              Inga deltagare hittades.
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
);

export default AttendanceWeekView;
